<header>
  <span class="dialog-title">Custom Metric Timestamp</span>
  <oph-x-button (buttonClick)="onClose()"></oph-x-button>
</header>

<div class="content-container">
  <button class="select-button" (click)="picker.open()">
    <span class="text">{{ form.get('date')?.value | moment: 'M/D/YYYY' }}</span>
    <mat-icon svgIcon="chevron-down"></mat-icon>
  </button>
  <input
    matInput
    [matDatepicker]="picker"
    [formControl]="$any(form.get('date'))"
    [max]="maxDate"
    [min]="minDate"
    placeholder="Choose a date"
  />
  <mat-datepicker #picker></mat-datepicker>

  <oph-time-selector
    [hoursControl]="$any(form.get('hours'))"
    [minutesControl]="$any(form.get('minutes'))"
    [ampmControl]="$any(form.get('ampm'))"
  ></oph-time-selector>
</div>

<div class="button-container">
  <oph-button
    color="gray"
    appearance="outline"
    [style]="{'border-width': '0.5px', 'border-radius': '8px'}"
    (click)="onClose()"
    >Cancel</oph-button
  >
  <oph-button color="green" [style]="{'border-radius': '8px'}" (click)="onSave()">Save</oph-button>
</div>
